"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenProviderError = void 0;
/**
 * An error that occurs in a token provider.
 */
class TokenProviderError extends Error {
    /**
     * Initializes a new instance of the @see TokenProviderError class.
     * @param message The error message
     * @param innerError The inner error that caused this token provider error.
     */
    constructor(message, innerError) {
        super(message);
        this.innerError = innerError;
    }
}
exports.TokenProviderError = TokenProviderError;
//# sourceMappingURL=tokenProviderError.js.map